import React					from "react";
import ReactCSSTransitionGroup	from "react-addons-css-transition-group";
import classNames				from "classnames";


function LoadingOverlay({ show }) {

	const classes = classNames({
		'c-loading-overlay' : true,
	})

	return (
		<ReactCSSTransitionGroup
			transitionName="example"
			transitionEnterTimeout={500}
			transitionLeaveTimeout={300}>
			{show
				? (
					<div className={classes}>
						<div>
							<div className="spinner" style={{width: "50px", height: "50px"}}/>
							<label>Chargement...</label>
						</div>
					</div>
				)
				:null
			}
		</ReactCSSTransitionGroup>
	);
}

export default LoadingOverlay;



// WEBPACK FOOTER //
// ./src/js/common/components/LoadingOverlay.js